import styled from 'styled-components';

export const StyledH2 = styled.h2`
  font-family: 'Mali', 'sans-serif';
  font-size: 1.5rem;
  width: 80%;
  padding-bottom: 10px;
  margin-bottom:1.0rem;
  margin-left: auto;
  margin-right: auto;
  text-decoration: none;
  border-bottom: 1px solid #ef476f;
  color: #ef476f;
  &:hover {
    color: #118ab2;
  };
  &:active {
    color: #eea111;
  };
`
